import { render, staticRenderFns } from "./plannedCompletedJustifiedChart.vue?vue&type=template&id=891b66be&scoped=true&"
import script from "./plannedCompletedJustifiedChart.vue?vue&type=script&lang=js&"
export * from "./plannedCompletedJustifiedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891b66be",
  null
  
)

export default component.exports